import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=98f0ed12&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=98f0ed12&prod&scoped=true&lang=css&external"
import style1 from "./Orders.vue?vue&type=style&index=1&id=98f0ed12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f0ed12",
  null
  
)

export default component.exports